const mailRegex = new RegExp(/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/);
const numberRegex = new RegExp(/^[0-9]+$/);
const zenkakuRegex = new RegExp(/^[^\x01-\x7E\xA1-\xDF]+$/);
const kanaRegex = new RegExp(/^[ァ-ヶー]+$/);
const passwordRegex = new RegExp(/^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,30}$/);

// 会員登録用メール送信バリデーション
const validateRegisterEmail = (mailType) => {
  const email = document.querySelector('input[name=send_email]');
  const emailConfirm = document.querySelector('input[name=email_confirm]');
  const privacyAgree = document.querySelector('input[name=privacyAgree]');
  const policyAgree = document.querySelector('input[name=policyAgree]');

  let error = false;

  initErrorMessage();

  if (email.value.length === 0) {
    error = displayErrorMessage(email, 'メールアドレスを入力してください');
  }

  if (!mailRegex.test(email.value)) {
    error = displayErrorMessage(email, '正しい形式を入力してください');
  }

  if (emailConfirm.value.length === 0) {
    error = displayErrorMessage(emailConfirm, 'ID（メールアドレス）確認用を入力してください');
  }

  if (!mailRegex.test(emailConfirm.value)) {
    error = displayErrorMessage(emailConfirm, '正しい形式を入力してください');
  }

  if (email.value != emailConfirm.value) {
    error = displayErrorMessage(emailConfirm, 'メールアドレスが一致しません');
  }

  if (!privacyAgree.checked) {
    error = displayErrorMessage(privacyAgree, 'プライバシーポリシーに同意してください');
  }

  if (!policyAgree.checked) {
    error = displayErrorMessage(policyAgree, '利用規約に同意してください');
  }

  if (error) {
    return null;
  }

  return {
    email: email.value,
    mailType
  }
};

// パスワード再設定用メール送信バリデーション
const validateResetPasswordEmail = () => {
  const email = document.querySelector('input[name=send_email]');
  let error = false;

  initErrorMessage();

  if (email.value.length === 0) {
    error = displayErrorMessage(email, 'メールアドレスを入力してください');
  }

  if (!mailRegex.test(email.value)) {
    error = displayErrorMessage(email, '正しい形式を入力してください');
  }

  if (error) {
    return null;
  }

  return {
    email: email.value
  };
};

// 電話番号更新バリデーション
const validatePhone = () => {
  const phoneNumber = document.querySelector('input[name=phoneNumber]');
  const SmsAuthFlg = document.querySelector('input[name=sms_auth_flg]');
  const smsAuthInput = document.querySelectorAll('input[name=auth_code]');
  let error = false;
  let smsAuthCode = '';

  initErrorMessage();

  if (phoneNumber.value.length === 0) {
    error = displayErrorMessage(phoneNumber, '電話番号を入力してください');
  }

  if (!(phoneNumber.value.length === 10 || phoneNumber.value.length === 11) || !numberRegex.test(phoneNumber.value)) {
    error = displayErrorMessage(phoneNumber, 'ハイフンなし半角数字10 or 11桁で入力してください');
  }

  // 特殊会員でない場合
  if (SmsAuthFlg.value != VIP_STATUS.VIP) {
    for (let i = 0; i < smsAuthInput.length; i++) {
      if (smsAuthInput[i].value.length === 0) {
        error = displayErrorMessage(smsAuthInput[i].parentNode, '認証コードを入力してください');
        break;
      }

      if (smsAuthInput[i].value.length !== 1) {
        error = displayErrorMessage(smsAuthInput[i].parentNode, '認証コードは4桁で入力してください');
        break;
      }

      smsAuthCode = smsAuthCode.concat(smsAuthInput[i].value);
    }
  }

  if (error) {
    return null;
  }

  let params = {
    phoneNumber: phoneNumber.value,
    type: SmsAuthFlg.value != '' ? SmsAuthFlg.value : VIP_STATUS.NORMAL
  };

  if (SmsAuthFlg.value == VIP_STATUS.VIP) {
    return params;
  }

  return {
    ...params,
    smsAuthCode
  };
};

// SMS認証コード送信バリデーション
const validateSmsAuth = (token, smsFlg) => {
  if (smsFlg !== '') {
    smsFlg = String(smsFlg);
  }
  let phoneNumber = document.querySelector('input[name=phoneNumber]');
  if (smsFlg === '0') {
    // IVR認証
    phoneNumber = document.querySelector('input[name=smartPhoneNumber]');
  }
  const language = document.documentElement.lang;
  let error = false;

  initErrorMessage();

  if (phoneNumber.value.length === 0) {
    error = displayErrorMessage(phoneNumber, '電話番号を入力してください');
  }

  if (!(phoneNumber.value.length === 10 || phoneNumber.value.length === 11) || !numberRegex.test(phoneNumber.value)) {
    error = displayErrorMessage(phoneNumber, 'ハイフンなし半角数字10 or 11桁で入力してください');
  }

  if (error) {
    return null;
  }

  return {
    phoneNumber: phoneNumber.value,
    token,
    language: language == 'ja' || language == '' ? '1' : '2',
    smsFlg: smsFlg
  };
};

// ログインバリデーション
const validateLogin = () => {
  const email = document.querySelector('input[name=login_email]');
  const password = document.querySelector('input[name=login_password]');
  const redirectUrl = document.querySelector('input[name=redirectUrl]');
  const appFlg = document.querySelector('input[name=appFlg]');
  let error = false;

  initErrorMessage();

  if (email.value.length === 0) {
    error = displayErrorMessage(email, 'ID（メールアドレス）を入力してください');
  }

  if (!mailRegex.test(email.value)) {
    error = displayErrorMessage(email, '正しい形式を入力してください');
  }

  if (password.value.length === 0) {
    error = displayErrorMessage(password, 'パスワードを入力してください');
  }

  if (error) {
    return null;
  }

  return {
    email: email.value,
    password: password.value,
    redirectUrl: redirectUrl.value,
    appFlg: appFlg.value
  };
};

// 会員登録バリデーション
const validateRegisterCustomer = (token, type = null) => {
  const password = document.querySelector('input[name=password]');
  const passwordConfirmation = document.querySelector('input[name=password_confirmation]');
  const lastName = document.querySelector('._name input[name=lastName]');
  const firstName = document.querySelector('._name input[name=firstName]');
  const lastKana = document.querySelector('._name input[name=lastKana]');
  const firstKana = document.querySelector('._name input[name=firstKana]');
  const country = document.querySelector('.c-select select.country');
  let postalCode = document.querySelector('._postcode input[name=postalCode]');
  let prefecture = document.querySelector('.c-select select.prefectures');
  const countyCityAddress = document.querySelector('input[name=countyCityAddress]');
  const townAddress = document.querySelector('input[name=townAddress]');
  const buildingName = document.querySelector('input[name=buildingName]');
  const phoneNumber = document.querySelector('input[name=phoneNumber]');
  const smsAuthInput = document.querySelectorAll('input[name=auth_code]');
  const birthYear = document.querySelector('.c-select select.year');
  const birthMonth = document.querySelector('.c-select select.month');
  const birthDay = document.querySelector('.c-select select.day');
  const sexEl = document.querySelectorAll('._sex input[name=sex]');
  const getNews = document.querySelector('._newsletter input[name=get_news]');
  const itemMailMagazine = document.querySelector('.f-newsletter input[name=itemMailMagazine]');
  const ecMailMagazine = document.querySelector('.f-newsletter input[name=ecMailMagazine]');
  const shopMailMagazine = document.querySelector('.f-newsletter input[name=shopMailMagazine]');
  const shopDMEl = document.querySelectorAll('._dm input[name=shopDM]');
  const brandlist = document.querySelectorAll('.f-interestBrands input[type=checkbox]');
  let error = false;
  let brandinterestlist = [];
  let sex = "0";
  let shopDM = "0";
  let smsAuthCode = '';
  let lang = WOVN.io.getCurrentLang().code;

  for (let i = 0; i < sexEl.length; i++) {
    if (sexEl[i].checked) {
      sex = sexEl[i].value;
      break;
    }
  }

  for (let i = 0; i < shopDMEl.length; i++) {
    if (shopDMEl[i].checked) {
      shopDM = shopDMEl[i].value;
      break;
    }
  }

  for (let j = 0; j < brandlist.length; j++) {
    if (brandlist[j].checked && j != 0) {
      brandinterestlist.push(j);
    }
  }

  initErrorMessage();

  if (password.value.length === 0) {
    error = displayErrorMessage(password, 'パスワードを入力してください');
  }

  if (!passwordRegex.test(password.value)) {
    error = displayErrorMessage(password, '半角英数字が混在する8文字以上30字以下（ログインIDと同じ値は設定不可）で入力してください');
  }

  if (passwordConfirmation.value.length === 0) {
    error = displayErrorMessage(passwordConfirmation, 'パスワード確認用を入力してください');
  }

  if (password.value != passwordConfirmation.value) {
    error = displayErrorMessage(passwordConfirmation, 'パスワードと一致しません');
  }

  if (!lastName.value.match(/\S/g)) {
    error = displayErrorMessage(lastName, '姓を入力してください');
  }

  if (!firstName.value.match(/\S/g)) {
    error = displayErrorMessage(firstName, '名を入力してください');
  }

  if(lang == 'ja'){
    if (lastKana.value.length === 0) {
      error = displayErrorMessage(lastKana, 'セイを入力してください');
    }
  
    if (!kanaRegex.test(lastKana.value)) {
      error = displayErrorMessage(lastKana, 'セイを全角カナで入力してください');
    }
  
    if (firstKana.value.length === 0) {
      error = displayErrorMessage(firstKana, 'メイを入力してください');
    }
  
    if (!kanaRegex.test(firstKana.value)) {
      error = displayErrorMessage(firstKana, 'メイを全角カナで入力してください');
    }
  }else{
    lastKana.value = '';
    firstKana.value = '';
  }

  // 「国/地域」が日本の場合
  if (country.value == 'JP') {
    if (postalCode.value.length === 0) {
      error = displayErrorMessage(postalCode, '郵便番号を入力してください');
    }

    if (prefecture.value == null || prefecture.value.length === 0) {
      error = displayErrorMessage(prefecture, '都道府県を選択してください');
    }

    if (countyCityAddress.value.length === 0) {
      error = displayErrorMessage(countyCityAddress, '住所1を入力してください');
    }
    if (townAddress.value.length === 0) {
      error = displayErrorMessage(townAddress, '住所2を入力してください');
    }
  } else {
    postalCode.value = '';
    prefecture.value = '';
  }

  if (postalCode.value.length !== 0) {
    postalCode.value = postalCode.value.replace('-', '');
    if (postalCode.value.length !== 7 || !numberRegex.test(postalCode.value)) {
      error = displayErrorMessage(postalCode, 'ハイフンなし半角数字7桁で入力してください');
    }
  }

  if (countyCityAddress.value.length !== 0 && countyCityAddress.value.length > 40) {
    error = displayErrorMessage(countyCityAddress, '住所1は40文字以内で入力してください');
  }

  if (townAddress.value.length !== 0 && townAddress.value.length > 40) {
    error = displayErrorMessage(townAddress, '住所2は40文字以内で入力してください');
  }

  if (buildingName.value.length !== 0 && buildingName.value.length > 40) {
    error = displayErrorMessage(buildingName, '建物名は40文字以内で入力してください');
  }

  // 特殊会員以外
  if (type != VIP_STATUS.VIP) {
    if (phoneNumber.value.length === 0) {
      error = displayErrorMessage(phoneNumber, '電話番号を入力してください');
    }

    if (!(phoneNumber.value.length === 10 || phoneNumber.value.length === 11) || !numberRegex.test(phoneNumber.value)) {
      error = displayErrorMessage(phoneNumber, 'ハイフンなし半角数字10 or 11桁で入力してください');
    }

    for (let i = 0; i < smsAuthInput.length; i++) {
      if (smsAuthInput[i].value.length === 0) {
        error = displayErrorMessage(smsAuthInput[i].parentNode, '認証コードを入力してください');
        break;
      }

      if (smsAuthInput[i].value.length !== 1) {
        error = displayErrorMessage(smsAuthInput[i].parentNode, '認証コードは4桁で入力してください');
        break;
      }

      smsAuthCode = smsAuthCode.concat(smsAuthInput[i].value);
    }
  }

  if (birthYear.value.length === 0 || birthMonth.value.length === 0 || birthDay.value.length === 0) {
    error = displayErrorMessage(birthYear, '生年月日を選択してください');
  }

  if (getNews.checked && !(itemMailMagazine.checked || ecMailMagazine.checked || shopMailMagazine.checked)) {
    error = displayErrorMessage(document.querySelector('._newsletter'), 'いずれか選択してください');
  }

  if (error) {
    return null;
  }

  let params = {
    password: password.value,
    lastName: lastName.value,
    firstName: firstName.value,
    lastKana: lastKana.value,
    firstKana: firstKana.value,
    sex,
    country: country.value,
    postalCode: postalCode.value,
    prefecture: prefecture.value,
    countyCityAddress: countyCityAddress.value,
    townAddress: townAddress.value,
    buildingName: buildingName.value,
    birthYear: Number(birthYear.value),
    birthMonth: Number(birthMonth.value),
    birthDay: Number(birthDay.value),
    itemMailMagazine: itemMailMagazine.checked ? '1' : '0',
    ecMailMagazine: ecMailMagazine.checked ? '1' : '0',
    shopMailMagazine: shopMailMagazine.checked ? '1' : '0',
    shopDM,
    brandinterestlist,
    token,
    language: lang == 'ja' ? '1' : '2',
  };

  // 移行会員以外
  if (type) {
    params = {
      ...params,
      type
    };
  }

  // 特殊会員
  if (type == VIP_STATUS.VIP) {
    return params;
  }

  return {
    ...params,
    phoneNumber: phoneNumber.value,
    smsAuthCode
  };
};

// 会員更新バリデーション
const validateEditCustomer = () => {
  const lastName = document.querySelector('._name input[name=lastName]');
  const firstName = document.querySelector('._name input[name=firstName]');
  const lastKana = document.querySelector('._name input[name=lastKana]');
  const firstKana = document.querySelector('._name input[name=firstKana]');
  const country = document.querySelector('.c-select select.country');
  let postalCode = document.querySelector('._postcode input[name=postalCode]');
  let prefecture = document.querySelector('.c-select select.prefectures');
  const countyCityAddress = document.querySelector('input[name=countyCityAddress]');
  const townAddress = document.querySelector('input[name=townAddress]');
  const buildingName = document.querySelector('input[name=buildingName]');
  const sexEl = document.querySelectorAll('._sex input[name=sex]');
  const getNews = document.querySelector('._newsletter input[name=get_news]');
  const itemMailMagazine = document.querySelector('.f-newsletter input[name=itemMailMagazine]');
  const ecMailMagazine = document.querySelector('.f-newsletter input[name=ecMailMagazine]');
  const shopMailMagazine = document.querySelector('.f-newsletter input[name=shopMailMagazine]');
  const shopDMEl = document.querySelectorAll('._dm input[name=shopDM]');
  const brandlist = document.querySelectorAll('.f-interestBrands input[type=checkbox]');
  let error = false;
  let brandinterestlist = [];
  let sex = "0";
  let shopDM = "0";
  let lang = WOVN.io.getCurrentLang().code;

  for (let i = 0; i < sexEl.length; i++) {
    if (sexEl[i].checked) {
      sex = sexEl[i].value;
      break;
    }
  }

  for (let i = 0; i < shopDMEl.length; i++) {
    if (shopDMEl[i].checked) {
      shopDM = shopDMEl[i].value;
      break;
    }
  }

  for (let j = 0; j < brandlist.length; j++) {
    if (brandlist[j].checked && j != 0) {
      brandinterestlist.push(j);
    }
  }

  initErrorMessage();

  if (!lastName.value.match(/\S/g)) {
    error = displayErrorMessage(lastName, '姓を入力してください');
  }

  if (!firstName.value.match(/\S/g)) {
    error = displayErrorMessage(firstName, '名を入力してください');
  }

  if(lang == 'ja'){
    if (lastKana.value.length === 0) {
      error = displayErrorMessage(lastKana, 'セイを入力してください');
    }
  
    if (!kanaRegex.test(lastKana.value)) {
      error = displayErrorMessage(lastKana, '全角カナで入力してください');
    }
  
    if (firstKana.value.length === 0) {
      error = displayErrorMessage(firstKana, 'メイを入力してください');
    }
  
    if (!kanaRegex.test(firstKana.value)) {
      error = displayErrorMessage(firstKana, '全角カナで入力してください');
    }
  }else{
    lastKana.value = '';
    firstKana.value = '';
  }

  // 「国/地域」が日本の場合
  if (country.value == 'JP') {
    if (postalCode.value.length === 0) {
      error = displayErrorMessage(postalCode, '郵便番号を入力してください');
    }

    if (postalCode.value.length !== 0) {
      postalCode.value = postalCode.value.replace('-', '');
      if (postalCode.value.length !== 7 || !numberRegex.test(postalCode.value)) {
        error = displayErrorMessage(postalCode, 'ハイフンなし半角数字7桁で入力してください');
      }
    }

    if (prefecture.value == null || prefecture.value.length === 0) {
      error = displayErrorMessage(prefecture, '都道府県を選択してください');
    }

    if (countyCityAddress.value.length === 0) {
      error = displayErrorMessage(countyCityAddress, '住所1を入力してください');
    }
    if (townAddress.value.length === 0) {
      error = displayErrorMessage(townAddress, '住所2を入力してください');
    }
  } else {
    postalCode.value = '';
    prefecture.value = '';
  }

  if (countyCityAddress.value.length !== 0 && countyCityAddress.value.length > 40) {
    error = displayErrorMessage(countyCityAddress, '住所1は40文字以内で入力してください');
  }
  
  if (townAddress.value.length !== 0 && townAddress.value.length > 40) {
    error = displayErrorMessage(townAddress, '住所2は40文字以内で入力してください');
  }

  if (buildingName.value.length !== 0 && buildingName.value.length > 40) {
    error = displayErrorMessage(buildingName, '建物名は40文字以内で入力してください');
  }

  if (getNews.checked && !(itemMailMagazine.checked || ecMailMagazine.checked || shopMailMagazine.checked)) {
    error = displayErrorMessage(document.querySelector('._newsletter'), 'いずれか選択してください');
  }

  if (error) {
    return null;
  }

  let params = {
    lastName: lastName.value,
    firstName: firstName.value,
    lastKana: lastKana.value,
    firstKana: firstKana.value,
    sex,
    country: country.value,
    postalCode: postalCode.value,
    prefecture: prefecture.value,
    countyCityAddress: countyCityAddress.value,
    townAddress: townAddress.value,
    buildingName: buildingName.value,
    itemMailMagazine: itemMailMagazine.checked ? '1' : '0',
    ecMailMagazine: ecMailMagazine.checked ? '1' : '0',
    shopMailMagazine: shopMailMagazine.checked ? '1' : '0',
    shopDM,
    brandinterestlist,
    language: lang == 'ja' ? '1' : '2',
  };

  return params;
};

// パスワード更新バリデーション
const validateEditPassword = () => {
  const oldPassword = document.getElementById('old_password');
  const newPassword = document.getElementById('new_password');
  const newPasswodConfirmation = document.getElementById('new_password_confirmation');
  let error = false;

  initErrorMessage();

  if (oldPassword.value.length === 0) {
    error = displayErrorMessage(oldPassword, '現在のパスワードを入力してください');
  }

  if (newPassword.value.length === 0) {
    error = displayErrorMessage(newPassword, '新しいパスワードを入力してください');
  }

  if (!passwordRegex.test(newPassword.value)) {
    error = displayErrorMessage(newPassword, '半角英数字が混在する8文字以上30字以下（ログインIDと同じ値は設定不可）で入力してください');
  }

  if (oldPassword.value == newPassword.value) {
    error = displayErrorMessage(newPassword, '現在のパスワードと異なる文字列を入力してください');
  }

  if (newPasswodConfirmation.value.length === 0) {
    error = displayErrorMessage(newPasswodConfirmation, '新しいパスワード確認用を入力してください');
  }

  if (newPassword.value != newPasswodConfirmation.value) {
    error = displayErrorMessage(newPasswodConfirmation, 'パスワードと一致しません');
  }

  if (error) {
    return null;
  }

  return {
    oldPassword: oldPassword.value,
    newPassword: newPassword.value
  };
};

// メールアドレス更新用メールバリデーション
const validateEditEmail = () => {
  const email = document.querySelector('input[name=email]');
  const emailConfirm = document.querySelector('input[name=email_confirm]');
  let error = false;

  initErrorMessage();

  if (email.value.length === 0) {
    error = displayErrorMessage(email, 'ID（メールアドレス）を入力してください');
  }

  if (!mailRegex.test(email.value)) {
    error = displayErrorMessage(email, '正しい形式を入力してください');
  }

  if (emailConfirm.value.length === 0) {
    error = displayErrorMessage(emailConfirm, 'ID（メールアドレス）確認用を入力してください');
  }

  if (!mailRegex.test(emailConfirm.value)) {
    error = displayErrorMessage(emailConfirm, '正しい形式を入力してください');
  }

  if (email.value != emailConfirm.value) {
    error = displayErrorMessage(emailConfirm, 'メールアドレスが一致しません');
  }

  if (error) {
    return null;
  }

  return {
    email: email.value
  };
};

// パスワード再設定バリデーション
const validateResetPassword = (token) => {
  const password = document.getElementById('password');
  const passwodConfirmation = document.getElementById('password_confirmation');
  let error = false;

  initErrorMessage();

  if (password.value.length === 0) {
    error = displayErrorMessage(password, 'パスワードを入力してください。');
  }

  if (!passwordRegex.test(password.value)) {
    error = displayErrorMessage(password, '半角英数字が混在する8文字以上30字以下（ログインIDと同じ値は設定不可）で入力してください');
  }

  if (passwodConfirmation.value.length === 0) {
    error = displayErrorMessage(passwodConfirmation, 'パスワード確認用を入力してください。');
  }

  if (password.value != passwodConfirmation.value) {
    error = displayErrorMessage(passwodConfirmation, 'パスワードと一致しません。');
  }

  if (error) {
    return null;
  }

  return {
    newPassword: password.value,
    token
  };
};

// ポイント利用バリデーション
const validateUsePoint = (point) => {
  let error = false;
  const checkoutBtn = document.getElementById('checkoutError')

  initErrorMessage();

  if (point.value.length === 0) {
    error = displayErrorMessage(checkoutBtn, '利用するポイントを入力してください。');
    return null;
  }

  const num = Number(point.value);
  if (num === 0) {
    error = displayErrorMessage(checkoutBtn, 'ポイントは100ポイント以上100ポイント単位で利用できます。');
  }

  if (num % 100 !== 0) {
    error = displayErrorMessage(checkoutBtn, 'ポイントは100ポイント以上100ポイント単位で利用できます。');
  }

  const useInput = document.querySelector('.js-usepoint');
  const max = useInput.max > 300000 ? 300000 : useInput.max;

  if (num > Number(max)) {
    error = displayErrorMessage(checkoutBtn, '利用ポイント上限を超えています。');
  }

  if (error) {
    return null;
  }

  return {
    points: num
  };
};
